import { useCallback, useState } from 'react'
import { fireGtmEvent } from 'lib/gtm'
import { SortKey, SortOrder } from 'types/checkout'

const useSelectSort = (): [
  sortKey: SortKey,
  sortOrder: SortOrder,
  sortLabel: string,
  selectSort: (value: string) => void
] => {
  const [sortKey, setSortKey] = useState<SortKey>('checkout_at')
  const [sortOrder, setSortOrder] = useState<SortOrder>('desc')
  const [sortLabel, setSortLabel] = useState<string>('注文（降順）')
  const selectSort = useCallback(
    (value: string) => {
      switch (value) {
        case '注文（昇順）':
          setSortKey('checkout_at')
          setSortOrder('asc')
          setSortLabel(value)
          fireGtmEvent('select_order_sort', 'order_sort_asc')
          break
        case '注文（降順）':
          setSortKey('checkout_at')
          setSortOrder('desc')
          setSortLabel(value)
          fireGtmEvent('select_order_sort', 'order_sort_desc')
          break
        case '来店予定時刻（昇順）':
          setSortKey('pickup_time')
          setSortOrder('asc')
          setSortLabel(value)
          fireGtmEvent('select_order_sort', 'pickuptime_sort_asc')
          break
        case '来店予定時刻（降順）':
          setSortKey('pickup_time')
          setSortOrder('desc')
          setSortLabel(value)
          fireGtmEvent('select_order_sort', 'pickuptime_sort_desc')
          break
        default:
          setSortKey('checkout_at')
          setSortOrder('desc')
          break
      }
    },
    [setSortKey, setSortOrder]
  )
  return [sortKey, sortOrder, sortLabel, selectSort]
}

export default useSelectSort
